import { useQuery } from '@tanstack/react-query'
import { getSubsModuleLabs } from '../lib/api/Subscription-Service'
import SingleLabCard from '../components/Subscription-Plans/SingleLabCard'
import { useOutletContext, useParams } from 'react-router-dom'
import { Search } from 'lucide-react'

import FreeLabCard from '../components/Subscription-Plans/FreeLabCard'
import { useMemo } from 'react'
import SubscriptionLabsSkeleton from '../components/common/Loader/SubscriptionLabsSkeleton'

const SubscriptionLabs = () => {
  const { plan, moduleId } = useParams()
  const { searchQuery } = useOutletContext()

  const { data: labsData, isLoading } = useQuery({
    queryKey: ['get-all-subscription-module-labs', moduleId],
    queryFn: () => getSubsModuleLabs(moduleId),
    enabled: !!moduleId,
  })

  // Filter labs based on search query
  const filteredLabs = useMemo(() => {
    if (!labsData?.labs || !searchQuery?.trim()) {
      return labsData?.labs || []
    }

    return labsData.labs.filter(
      (lab) =>
        lab.title?.toLowerCase().includes(searchQuery.toLowerCase().trim()) ||
        lab.description?.toLowerCase().includes(searchQuery.toLowerCase().trim())
    )
  }, [labsData?.labs, searchQuery])

  const isLabEmpty = filteredLabs.length === 0

  const isFreePlan = plan === 'Free'

  return (
    <div className="w-full space-y-4">
      {isLoading ? (
        <SubscriptionLabsSkeleton />
      ) : isLabEmpty ? (
        <div className="w-full flex flex-col items-center justify-center text-center p-12 text-gray-500 animate-fadeIn">
          <Search className="h-12 w-12 mb-4 text-gray-400" />
          <h3 className="text-lg font-semibold mb-2">No labs found</h3>
          <p>Try adjusting your search or filter to find what you're looking for</p>
        </div>
      ) : (
        <div className="w-full grid sm:grid-cols-2 md:grid-cols-3 gap-4">
          {filteredLabs.map((lab, index) => {
            if (isFreePlan) return <FreeLabCard key={lab._id} lab={lab} index={index} />
            return <SingleLabCard key={lab._id} lab={lab} index={index} />
          })}
        </div>
      )}
    </div>
  )
}

export default SubscriptionLabs
